var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"hotels","title":"Hotel","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name'
    },
    {
      component: 'FEditor',
      key: 'content',
      label: 'Content'
    }
  ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }